import { createSelector } from 'reselect'

const select = (state) => state.breadcrumbs
const selectRouting = (state) => state.routing
const selectDevices = (state) => state.devices

const selectTitle = createSelector(select, (breadcrumbs) => breadcrumbs.title)

const selectDevice = createSelector(
  selectDevices,
  selectRouting,
  (devices, routing) => {
    const id = routing.locationBeforeTransitions.query.device
    return (
      id && devices.devices.find((device) => device.id === parseInt(id, 10))
    )
  }
)

const selectContentType = createSelector(selectRouting, (routing) => {
  let contentType = null
  const pathname = routing.locationBeforeTransitions.pathname

  if (pathname.search('faq/') > 0) {
    contentType = 'FAQ'
  } else if (pathname.search('tutorial/') > 0) {
    contentType = 'Tutorial'
  } else if (pathname.search('guide') > 0) {
    contentType = 'Guide'
  }
  return contentType
})

export { selectTitle, selectDevice, selectContentType }
